import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { ReportsService } from '../../../core/services/reports/reports.service';
import { AccountsService } from '../../../core/services/accounts/accounts.service';
import { BrandService } from '../../../core/services/brand/brand.service';
import { Chart, registerables } from 'chart.js';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { FilterComponent } from './filter/filter.component';
import { start } from 'node:repl';
import Swal from 'sweetalert2';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';

Chart.register(...registerables);
type SearchParamsEst = {
  [key: string]: any;
};

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
}
@Component({
  selector: 'app-reports-evo-view',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    RouterLink,
    ReactiveFormsModule,
    FormsModule,
    FilterComponent
  ],
  templateUrl: './reports-evo-campaign-view.component.html',
  styleUrls: ['./reports-evo-campaign-view.component.css'],
})

export class ReportsEvoCampaignViewComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator2!: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator3!: MatPaginator;

  showForm = false;
  type: string = '';
  subType: string = '';
  chart: Chart | undefined;

  dataSource = new MatTableDataSource<any>();
  dataSource2 = new MatTableDataSource<any>();
  dataSource3 = new MatTableDataSource<any>();

  showKpis: boolean = false;

  accountType: string | null = null;
  orderData: any[] = [];
  ladata: any = [];
  searchParamsClickBar: SearchParamsEst = {};
  orderDataBar: any[] = [];
  showTable = false;
  typeOrders = "";

  sortColumn = 'name';
  sortDirection = 'asc';

  sortColumn2 = 'broker_name';
  sortDirection2 = 'asc';

  sortColumn3 = 'date';
  sortDirection3 = 'desc';

  campaignTable: boolean = false;

  stage: string = '';
  stage_end_date: string = '';
  stage_start_date: string = '';
  showFilterText: boolean = false;

  pageNumber: number = 0;
  pageSize: number = 20;
  searchParams: any = {};

  cargaladata: any = [];

  brokerData: AccountData[] = [];
  vendorData: AccountData[] = [];
  supplierData: AccountData[] = [];
  brands: any[] = [];

  data: any = [];
  fatherKpis: any = [];
  kpis: any = [];
  campaignName: string = '';
  data_table: any = [];
  data_table2: any = [];
  data_table3: any = [];
  sortedKeys: string[] = [];

  displayedColumns: string[] = ['reference', 'name', 'start', 'units', 'sent', 'risk_started', 'risk_approved', 'contract_signed', 'contract_accepted', 'vehicle_delivered'];
  displayedColumns2: string[] = ['name', 'sent', 'risk_started', 'risk_approved', 'contract_signed', 'contract_accepted', 'vehicle_delivered'];


  chartLabels: string[] = [];
  datasetSent: number[] = [];
  datasetRiskStarted: number[] = [];
  datasetRiskApproved: number[] = [];
  datasetContractSigned: number[] = [];
  datasetVehicleDelivered: number[] = [];

  myLineChart!: Chart;

  orderStageData: {
    stage: string;
    requiresAction: number;
    noAction: number;
  }[] = [];

  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource2.sort = this.sort;
  }
  constructor(
    private route: ActivatedRoute,

    private location: Location,
    private alertService: AlertService,
    private reportsService: ReportsService,
    private accountService: AccountsService,
    private brandService: BrandService,
    private authStateService: AuthStateService,
    private translate: TranslateService,
    private campaignService: CampaignsService,
  ) {
    this.accountType = this.authStateService.getAccountType();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.type = params.get('type') || 'campaign';
      this.subType = params.get('subtype') || '';
      this.fetchAllData();
    });
  }

  private fetchAllData() {
    Promise.all([
      this.fetchData2(),
      this.fetchData3(),
      this.fetchData10(),
    ]).then(() => {
      this.cargaladata.flag = true;
      this.ladata = this.cargaladata;
     
    });
  }
 fetchData10(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.campaignService.getCampaigns().subscribe({
        next: (data) => {
          this.cargaladata.campaignData = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
  fetchData2(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.accountService.getData().subscribe({
        next: (response: ApiResponse) => {
          if (!response || !response.data) {
            resolve();
            return;
          }
          const data: AccountData[] = response.data;
          this.cargaladata.brokerData = data.filter(
            (item) => item.type === 'broker'
          );
          this.cargaladata.supplierData = data.filter(
            (item) => item.type === 'supplier'
          );
          this.cargaladata.vendorData = data.filter(
            (item) => item.type === 'vendor'
          );
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData3(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.brandService.getData().subscribe({
        next: (data) => {
          this.cargaladata.brands = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

  onPageChange(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.fetchCampaingStages();
  }


  fetchCampaingStages(): Promise<void> {
    this.showFilterText = true;

    return new Promise((resolve, reject) => {
      this.searchParams['sortColumn'] = this.sortColumn;
      this.searchParams['sortDirection'] = this.sortDirection;
      this.reportsService.getDataEvolutionCampaign(this.pageNumber,
        this.pageSize, this.searchParams).subscribe({
          next: (data) => {
            const res = data?.data;
            if (!res || !res.tableData) {
              this.alertService.close();
              resolve();
              return;
            }

            this.data = res.chartData;
            this.fatherKpis = res.kpisData;
            this.kpis = res.kpisData;
            this.showKpis = true;
            this.data_table = res.tableData.data || [];
            this.pageNumber = res.tableData.meta?.current_page || 1;
            this.pageSize = res.tableData.meta?.per_page || 20;

            this.setupTable(this.sortColumn);

            setTimeout(() => {
              if (this.paginator) {
                this.paginator.pageSizeOptions = [5, 10, 20];
                this.paginator.pageSize = this.pageSize;
                this.paginator.pageIndex = this.pageNumber - 1;
                this.paginator.length = res.tableData.meta?.total || 0;
              }
            });

            this.alertService.close();
            resolve();
          },

          error: (error) => {
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }
  broker: any = null;
  campaign_reference_id: string = '';
  fetchOrderStages(reference: string, name: string): Promise<void> {
    this.campaign_reference_id = reference;
    this.campaignName =
      this.campaignName == '' ? ' > ' + name : this.campaignName;
    this.showFilterText = true;
    this.alertService.loading();
    return new Promise((resolve, reject) => {
      let auxParams = {} as any;
      this.searchParams['broker_reference_id[in]'] ? auxParams['broker_reference_id[in]'] = this.searchParams['broker_reference_id[in]'] : null;
      this.searchParams.date_type ? auxParams['date_type'] = this.searchParams.date_type : null;
      this.searchParams.period_type ? auxParams['period_type'] = this.searchParams.period_type : null;
      this.searchParams.start_date ? auxParams['start_date'] = this.searchParams.start_date : null;
      this.searchParams.end_date ? auxParams['end_date'] = this.searchParams.end_date : null;

      auxParams['sortColumn'] = this.sortColumn3;
      auxParams['sortDirection'] = this.sortDirection3;
      this.reportsService
        .getDataEvolutionOrdersCampaign(
          this.pageNumber,
          this.pageSize,
          auxParams,
          reference
        )
        .subscribe({
          next: (data) => {
            try {
              const res = data?.data;
              if (!res) {
                this.alertService.close();
                resolve();
                return;
              }

              if (res.broker_id) {
                this.broker = res.broker_id;
              }
              this.data = res.chartData;
              this.data_table2 = res.brokerTableData?.data || [];
              this.data_table3 = res.dateTableData?.data || [];
              this.kpis = res.kpisData;

              this.showKpis = true;
              this.setupTable2(this.sortColumn);
              this.setupTable3(this.sortColumn);
              this.campaignTable = true;
            } catch (e) {
              console.error('[fetchOrderStages] Error procesando respuesta:', e);
            }
            this.alertService.close();
            resolve();
          },

          error: (error) => {
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }

  setupTable(order: any = 'asc'): void {
    this.dataSource.data = this.data_table;
    const formattedData = Object.keys(this.data_table).map((key) => ({
      ...this.data_table[key],
    }));

    // Ordenamos los datos por fecha (YYYY-MM)
    formattedData.sort((a, b) => {
      const nameA = typeof a.campaign === 'string' ? a.campaign : '';
      const nameB = typeof b.campaign === 'string' ? b.campaign : '';
      if (order === 'asc') {
        return nameA.localeCompare(nameB);
      } else {
        return nameB.localeCompare(nameA);
      }
    });

    this.dataSource.data = formattedData;
  }

  setupTable2(order: any = 'asc'): void {
    this.dataSource2.data = this.data_table2;
    const formattedData = Object.keys(this.data_table2).map((key) => ({
      ...this.data_table2[key],
      /*   risk_started: this.data_table[key].ratio_risk_started ? this.data_table[key].risk_started + " (" + this.data_table[key].ratio_risk_started + ")" : this.data_table[key].risk_started,
        risk_approved: this.data_table[key].ratio_risk_approved ? this.data_table[key].risk_approved + " (" + this.data_table[key].ratio_risk_approved + ")" : this.data_table[key].risk_approved,
        contract_signed: this.data_table[key].ratio_contract_signed ? this.data_table[key].contract_signed + " (" + this.data_table[key].ratio_contract_signed + ")" : this.data_table[key].contract_signed,
        vehicle_delivered: this.data_table[key].ratio_vehicle_delivered ? this.data_table[key].vehicle_delivered + " (" + this.data_table[key].ratio_vehicle_delivered + ")" : this.data_table[key].vehicle_delivered,
   */
    }));

    formattedData.sort((a, b) => {
      const nameA = typeof a.broker === 'string' ? a.broker : '';
      const nameB = typeof b.broker === 'string' ? b.broker : '';
      if (order === 'asc') {
        return nameA.localeCompare(nameB);
      } else {
        return nameB.localeCompare(nameA);
      }
    });
    this.dataSource2.data = formattedData;
  }

  setupTable3(order: any = 'asc'): void {
    this.dataSource3.data = this.data_table3;

    const formattedData = Object.keys(this.data_table3).map((key) => ({
      ...this.data_table3[key],
    }));

    formattedData.sort((a, b) => {
      const [yearA, monthA] = a.date.includes('W')
        ? a.date.split('-W').map(Number)
        : a.date.split('-').map(Number);
      const [yearB, monthB] = b.date.includes('W')
        ? b.date.split('-W').map(Number)
        : b.date.split('-').map(Number);
      const dateA = new Date(yearA, monthA - 1).getTime();
      const dateB = new Date(yearB, monthB - 1).getTime();

      if (order === 'asc') {
        return dateA - dateB; // Orden ascendente
      } else {
        return dateB - dateA; // Orden descendente
      }
    });

    this.dataSource3.data = formattedData;
  }

  goBackTable() {

    this.location.go('/reports/prescription-broker/campaign/');
    this.data_table2 = [];
    this.data_table3 = [];
    this.dataSource2.data = [];
    this.dataSource3.data = [];
    this.campaignTable = false;
    this.campaignName = '';
    this.kpis = this.fatherKpis;
  }

  filterChanged(searchParams: any): void {
    let aux = searchParams;
    if (!aux.end_date) {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      aux.end_date = `${year}-${month}-${day}`;
    }

    if (!aux.start_date) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1); // Restar un año
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      aux.start_date = `${year}-${month}-${day}`;
    }
    this.stage_start_date = searchParams.start_date || '';
    this.stage_end_date = searchParams.end_date || '';
    this.searchParams = searchParams;
    this.pageNumber = 1;
    this.alertService.loading('swal_messages.please_wait');
  
    if (this.campaignTable) {
      this.fetchOrderStages(this.campaign_reference_id, this.campaignName)
        .then(() => {
        })
        .catch((error) => {
          console.error('Error loading clients:', error);
          this.alertService.error('Error loading clients');
        });
    } else {
      this.fetchCampaingStages()
        .then(() => {
        })
        .catch((error) => {
          console.error('Error loading clients:', error);
          this.alertService.error('Error loading clients');
        });
    }
  }

  sortMap: { [key: string]: string } = {
    name: 'name',
    reference: 'reference',
    date: 'date',
    month_year: 'month_year',
  };

  onSortChange(event: string) {
    this.sortColumn = this.sortMap[String(event)];
    if (this.sortDirection == 'asc') {
      this.sortDirection = 'desc';

      //this.setupTable('desc');
    } else {
      this.sortDirection = 'asc';
      //this.setupTable('asc');
    }
    this.fetchCampaingStages();
  }

  onSortChange2(event: string) {
    this.sortColumn2 = this.sortMap[String(event)];
    if (this.sortDirection2 == 'asc') {
      this.sortDirection2 = 'desc';
      this.setupTable2('desc');
    } else {
      this.sortDirection2 = 'asc';
      this.setupTable2('asc');
    }
  }

  onSortChange3(event: string) {
    this.sortColumn3 = this.sortMap[String(event)];
    if (this.sortDirection3 == 'asc') {
      this.sortDirection3 = 'desc';
      this.setupTable3('desc');
    } else {
      this.sortDirection3 = 'asc';
      this.setupTable3('asc');
    }
  }

  getDirection(sortDirection: string): string {
    const directionMap: { [key: string]: string } = {
      asc: 'icon-arrow-up',
      desc: 'icon-arrow-down',
    };

    return directionMap[sortDirection] || 'icon-arrow-up';
  }

  onCampaignClick(campaignReference: string, name: string): void {
    this.location.go('/reports/prescription-broker/campaign/' + campaignReference);
    this.fetchOrderStages(campaignReference, name);
  }

  /*************** */

  async openExportOptions() {
    const message = await this.translate
      .get('swal_messages.export.text')
      .toPromise();
    const title = await this.translate
      .get('swal_messages.export.title')
      .toPromise();

    Swal.fire({
      title: title,
      text: message,
      icon: 'info',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Excel (.xlsx)',
      denyButtonText: 'CSV',
      cancelButtonText: 'XLS',
    }).then((result) => {
      if (result.isConfirmed) {
        this.exportCampaigns('xlsx');
      } else if (result.isDenied) {
        this.exportCampaigns('csv');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.exportCampaigns('xls');
      }
    });
  }

  exportCampaigns(type: string) {
    this.alertService.loading('swal_messages.please_wait');
    var searchParamsTemp = { ...this.searchParams };
    searchParamsTemp['format'] = type;

    this.reportsService.exportData(searchParamsTemp).subscribe({
      next: (data) => {
        let url = data.data.url;
        const a = document.createElement('a');
        a.href = url;
        a.click();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error);
      },
    });
  }


  translateTooltip(obj: Record<string, number>): string {
     return Object.entries(obj)
      .map(([key, value]) => `${value} ${this.translate.instant("badge-status_select-stage." + key)}`)
      .join('<br>');

  }

  
  async showStagePopup(stage:String,obj: Record<string, number>) {
    if (!obj) return;
    const text = this.translateTooltip(obj);
  
    Swal.fire({
         title: this.translate.instant('inputs.'+stage),
      html: text,
      icon: 'info',
      confirmButtonText: await this.translate.get('swal_messages.ok').toPromise()
    });
  }
}
